import { SET_ACCOUNT, CLEAR_ACCOUNT } from "./actionTypes";

const initialState = {
  account: null,
  idToken: null,
  accessToken: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCOUNT:
      return { ...state, account: action.payload };
    case CLEAR_ACCOUNT:
      return { ...state, account: null, idToken: null, accessToken: null };
    default:
      return state;
  }
};

export default authReducer;